import React from 'react';
import MaskedInput from 'react-text-mask';
import PropTypes from 'prop-types';

const maskCharacterMap = {
  "#": "^\\d",
  // "X": "^[a-z|A-Z]",
  // "*": "^[a-z|A-Z|0-9]",
}

const handleOnFocus = (props, event) => {
  props.onFocus && props.onFocus(false);
}

const handleOnBlur = (props, event) => {
  const { placeholder } = props;
  let mask = placeholder;
  let value = event.target && event.target.value;
  if (mask && value && value.length !== mask.length) {
    event.target.value = "";
    return (props.onChange && props.onChange(event)) ? props.onBlur(true) : props.onBlur;
  }
  props.onBlur && props.onBlur(true);
}

const TextNumberMask = props => {
  const { inputRef, placeholder, ...other } = props;
  const testMask = placeholder;
  const mask = testMask.split("");
  let customMask = [];
  mask.forEach(item => {
    let reg = maskCharacterMap[item] ? new RegExp(maskCharacterMap[item]) : item;
    customMask.push(reg);
  });

  return <MaskedInput {...other} ref={ref => inputRef && inputRef(ref ? ref.inputElement : null)}
    mask={customMask} guide={false} onBlur={handleOnBlur.bind(this, props)} onFocus={handleOnFocus.bind(this, props)} showMask />;
};

TextNumberMask.propTypes = {
  inputRef: PropTypes.func.isRequired,
};

export default TextNumberMask;
